"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tryCatch = void 0;
var tryCatch = function (tryFunc, catchFunc) {
    try {
        return tryFunc();
    }
    catch (error) {
        return catchFunc(error);
    }
};
exports.tryCatch = tryCatch;
